import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Users from '../../components/users/Users';

import * as appDialogConstants from '../../constants/appDialog';
import * as organizationMembersSelectors from '../../selectors/organizationMembersSelectors';
import * as organizationSelectors from '../../selectors/organizationSelectors';

import { ORGANIZATION_USER_ACTIONS } from '../../enums/UserActions';

const USER_ACTIONS = Object.keys(ORGANIZATION_USER_ACTIONS);

const OrganizationMemberList = props => {
    const { members, onAction, isAdmin } = props;

    const actions = isAdmin ? USER_ACTIONS : [];

    return <Users users={members} actions={actions} onAction={onAction} />;
};

OrganizationMemberList.propTypes = {
    members: PropTypes.array,
    onAction: PropTypes.func.isRequired,
    isAdmin: PropTypes.bool,
};

OrganizationMemberList.defaultProps = {
    members: [],
    isAdmin: false,
};

const mapStateToProps = state => ({
    members: organizationMembersSelectors.getMembers(state),
    isAdmin: organizationSelectors.getIsCurrentUserAdminForOrganization(state),
});

const mapDispatchToProps = dispatch => ({
    onAction: (usersIds, action) =>
        dispatch({
            type: appDialogConstants.OPEN_ACTION_DIALOG,
            payload: {
                usersIds,
                action: ORGANIZATION_USER_ACTIONS[action],
            },
        }),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(OrganizationMemberList);



// WEBPACK FOOTER //
// ./src/containers/organizationMembers/OrganizationMemberList.js